import cx from 'classnames';

import {RulesMobileMenu} from "./mobile-menu";
import {RulesDesktopMenu} from "./desktop-menu";


export const RulesMenu = (
    {
        menuItems,
        activeArticleId,
        setActiveArticleId,
        viewSize,
    }
) => {
    return (
        <div className={cx(
            "rules__menu",
            `rules__menu--${viewSize}`
        )}
        >
            { viewSize !== 'desktop' ?
                <RulesMobileMenu
                    {...{
                        menuItems,
                        activeArticleId,
                        setActiveArticleId,
                    }}
                />
                :
                <RulesDesktopMenu
                    {...{
                        menuItems,
                        activeArticleId,
                        setActiveArticleId,
                    }}
                />
            }
        </div>
    );
};